__webpack_require__.p = "https://cdn.wizbii.io/accelerate-dashboard/e7f566e73587f980387d824df28cb11b7cdb832e/fr/";